import {SELECT_TYPE} from '../../../utils/DropdownOptionPropsUtils';

export const fileTypeMainToSubResource = [
    {
        mainType: SELECT_TYPE, subType: SELECT_TYPE
    },

    //ARCHIVE
    {
        mainType: 'archive', subType: SELECT_TYPE
    },
    {
        mainType: 'archive', subType: 'x-freearc'
    },
    {
        mainType: 'archive', subType: 'bz'
    },
    {
        mainType: 'archive', subType: 'x-bzip'
    },
    {
        mainType: 'archive', subType: 'bz2'
    },
    {
        mainType: 'archive', subType: 'x-bzip2'
    },
    {
        mainType: 'archive', subType: 'gz'
    },
    {
        mainType: 'archive', subType: 'gzip'
    },
    {
        mainType: 'archive', subType: 'jar'
    },
    {
        mainType: 'archive', subType: 'java-archive'
    },
    {
        mainType: 'archive', subType: 'tar'
    },
    {
        mainType: 'archive', subType: 'x-tar'
    },
    {
        mainType: 'archive', subType: 'zip'
    },
    {
        mainType: 'archive', subType: '7z'
    },
    {
        mainType: 'archive', subType: 'x-7z-compressed'
    },
    {
        mainType: 'archive', subType: 'rar'
    },
    {
        mainType: 'archive', subType: 'vnd.rar'
    },

    //AUDIO
    {
        mainType: 'audio', subType: SELECT_TYPE
    },
    {
        mainType: 'audio', subType: 'aac'
    },
    {
        mainType: 'audio', subType: 'cda'
    },
    {
        mainType: 'audio', subType: 'x-cdf'
    },
    {
        mainType: 'audio', subType: 'midi'
    },
    {
        mainType: 'audio', subType: 'mid'
    },
    {
        mainType: 'audio', subType: 'x-midi'
    },
    {
        mainType: 'audio', subType: 'mp3'
    },
    {
        mainType: 'audio', subType: 'mpeg'
    },
    {
        mainType: 'audio', subType: 'oga'
    },
    {
        mainType: 'audio', subType: 'wav'
    },
    {
        mainType: 'audio', subType: 'weba'
    },
    {
        mainType: 'audio', subType: 'webm'
    },

    //DOCUMENT
    {
        mainType: 'document', subType: SELECT_TYPE
    },
    {
        mainType: 'document', subType: 'abw'
    },
    {
        mainType: 'document', subType: 'x-abiword'
    },
    {
        mainType: 'document', subType: 'doc'
    },
    {
        mainType: 'document', subType: 'msword'
    },
    {
        mainType: 'document', subType: 'docx'
    },
    {
        mainType: 'document', subType: 'vnd.openxmlformats-officedocument.wordprocessingml.document'
    },
    {
        mainType: 'document', subType: 'odt'
    },
    {
        mainType: 'document', subType: 'vnd.oasis.opendocument.text'
    },
    {
        mainType: 'document', subType: 'pdf'
    },

    //IMAGE
    {
        mainType: 'image', subType: SELECT_TYPE
    },
    {
        mainType: 'image', subType: 'apng'
    },
    {
        mainType: 'image', subType: 'avif'
    },
    {
        mainType: 'image', subType: 'bmp'
    },
    {
        mainType: 'image', subType: 'gif'
    },
    {
        mainType: 'image', subType: 'vnd.microsoft.icon'
    },
    {
        mainType: 'image', subType: 'ico'
    },
    {
        mainType: 'image', subType: 'jpeg'
    },
    {
        mainType: 'image', subType: 'jpg'
    },
    {
        mainType: 'image', subType: 'png'
    },
    {
        mainType: 'image', subType: 'svg'
    },
    {
        mainType: 'image', subType: 'svg+xml'
    },
    {
        mainType: 'image', subType: 'tif'
    },
    {
        mainType: 'image', subType: 'tiff'
    },
    {
        mainType: 'image', subType: 'webp'
    },

    //OTHER
    {
        mainType: 'other', subType: SELECT_TYPE
    },

    //PRESENTATION
    {
        mainType: 'presentation', subType: SELECT_TYPE
    },
    {
        mainType: 'presentation', subType: 'odp'
    },
    {
        mainType: 'presentation', subType: 'vnd.oasis.opendocument.presentation'
    },
    {
        mainType: 'presentation', subType: 'pptx'
    },
    {
        mainType: 'presentation', subType: 'vnd.openxmlformats-officedocument.presentationml.presentation'
    },
    {
        mainType: 'presentation', subType: 'ppt'
    },
    {
        mainType: 'presentation', subType: 'vnd.ms-powerpoint'
    },

    //SHEET
    {
        mainType: 'sheet', subType: SELECT_TYPE
    },
    {
        mainType: 'sheet', subType: 'csv'
    },
    {
        mainType: 'sheet', subType: 'ods'
    },
    {
        mainType: 'sheet', subType: 'vnd.oasis.opendocument.spreadsheet'
    },
    {
        mainType: 'sheet', subType: 'xls'
    },
    {
        mainType: 'sheet', subType: 'vnd.ms-excel'
    },
    {
        mainType: 'sheet', subType: 'xlsx'
    },
    {
        mainType: 'sheet', subType: 'vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    },

    //VIDEO
    {
        mainType: 'video', subType: SELECT_TYPE
    },
    {
        mainType: 'video', subType: 'webm'
    },
    {
        mainType: 'video', subType: 'avi'
    },
    {
        mainType: 'video', subType: 'x-msvideo'
    },
    {
        mainType: 'video', subType: 'mp4'
    },
    {
        mainType: 'video', subType: 'mpeg'
    },
    {
        mainType: 'video', subType: 'ogv'
    },
    {
        mainType: 'video', subType: 'ts'
    },
    {
        mainType: 'video', subType: '3gp'
    },
    {
        mainType: 'video', subType: '3gpp'
    },
    {
        mainType: 'video', subType: '3g2'
    },
    {
        mainType: 'video', subType: '3gpp2'
    }
];